var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/ui/input/input.tsx";
const _excluded = ["type", "icon", "className", "outerClassName", "hasError", "append", "prepend", "theme"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.includes.js";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import classNames from 'clsx';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import Icon from '../icon/icon';
import SvgIcon from '../icon/svg-icon';
import Tooltip from '../tooltip/tooltip';
const messages = defineMessages({
  showPassword: {
    "id": "input.password.show_password",
    "defaultMessage": "Show password"
  },
  hidePassword: {
    "id": "input.password.hide_password",
    "defaultMessage": "Hide password"
  }
});
/** Possible theme names for an Input. */

/** Form input element. */
const Input = /*#__PURE__*/React.forwardRef((props, ref) => {
  const intl = useIntl();

  const {
    type = 'text',
    icon,
    className,
    outerClassName,
    hasError,
    append,
    prepend,
    theme = 'normal'
  } = props,
        filteredProps = _objectWithoutProperties(props, _excluded);

  const [revealed, setRevealed] = React.useState(false);
  const isPassword = type === 'password';
  const togglePassword = React.useCallback(() => {
    setRevealed(prev => !prev);
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('mt-1 relative shadow-sm', outerClassName, {
      'rounded-md': theme !== 'search',
      'rounded-full': theme === 'search'
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 62,
      columnNumber: 7
    }
  }, icon ? /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 71,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    src: icon,
    className: "h-4 w-4 text-gray-700 dark:text-gray-600",
    "aria-hidden": "true",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 72,
      columnNumber: 13
    }
  })) : null, prepend ? /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-y-0 left-0 flex items-center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 77,
      columnNumber: 11
    }
  }, prepend) : null, /*#__PURE__*/React.createElement("input", _extends({}, filteredProps, {
    type: revealed ? 'text' : type,
    ref: ref,
    className: classNames({
      'text-gray-900 dark:text-gray-100 placeholder:text-gray-600 dark:placeholder:text-gray-600 block w-full sm:text-sm dark:ring-1 dark:ring-gray-800 focus:ring-primary-500 focus:border-primary-500 dark:focus:ring-primary-500 dark:focus:border-primary-500': ['normal', 'search'].includes(theme),
      'rounded-md bg-white dark:bg-gray-900 border-gray-400 dark:border-gray-800': theme === 'normal',
      'rounded-full bg-gray-200 border-gray-200 dark:bg-gray-800 dark:border-gray-800 focus:bg-white': theme === 'search',
      'bg-transparent border-none': theme === 'transparent',
      'pr-7': isPassword || append,
      'text-red-600 border-red-600': hasError,
      'pl-8': typeof icon !== 'undefined',
      'pl-16': typeof prepend !== 'undefined'
    }, className),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 82,
      columnNumber: 9
    }
  })), append ? /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-y-0 right-0 flex items-center pr-3",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 101,
      columnNumber: 11
    }
  }, append) : null, isPassword ? /*#__PURE__*/React.createElement(Tooltip, {
    text: revealed ? intl.formatMessage(messages.hidePassword) : intl.formatMessage(messages.showPassword),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 107,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-y-0 right-0 flex items-center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 114,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: togglePassword,
    tabIndex: -1,
    className: "text-gray-700 dark:text-gray-600 hover:text-gray-500 dark:hover:text-gray-400 h-full px-2 focus:ring-primary-500 focus:ring-2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 115,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(SvgIcon, {
    src: revealed ? require('@tabler/icons/eye-off.svg') : require('@tabler/icons/eye.svg'),
    className: "h-4 w-4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 121,
      columnNumber: 17
    }
  })))) : null);
});
export { Input as default };